module.exports = __webpack_public_path__ + "img/logoseebsantosdumont.686978be.png";